import React from "react";

interface StepFrameProps {
    /**
     * The step's heading. Omitted by the select step, where it would only duplicate the modal's own
     * header.
     */
    title?: string

    children: React.ReactNode
}

/**
 * The shared wrapper every wizard step renders inside, so the three steps look consistent (mirrors the
 * single-user modal's renderStateFrame). Each step supplies its own footer and actions as children.
 */
export const StepFrame = (props: StepFrameProps) => (
    <div>
        {props.title && <h4 className="mb-2">{props.title}</h4>}
        {props.children}
    </div>
);
